import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Directory from "./pages/Directory";
import ContactUs from "./pages/ContactUs";
import WhatsOn from "./pages/WhatsOn";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Floorguide from "./pages/Floorguide";
import PdfPage from "./pages/FilePage";
import { HelmetProvider } from "react-helmet-async";
import { useStores } from "./use.store";
import Splashscreen from "./Splashscreen";
import { observer } from "mobx-react-lite";
import FilePage from "./pages/FilePage";

const AppGate = observer(({ children }) => {
  const { mainStore } = useStores();

  if (!mainStore.appLoaded) {
    return <Splashscreen />;
  }

  return <div className="text-[#1C1C1CCC] w-full h-full">{children}</div>;
});

const App = () => {
  return (
    <AppGate>
      <HelmetProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/directory/:category" element={<Directory />} />
            <Route path="/floorguide" element={<Floorguide />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/whats-on" element={<WhatsOn />} />
            <Route path="/whats-on/:eventName" element={<WhatsOn />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/file" element={<FilePage />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </AppGate>
  );
};

export default App;
